import { useState, useEffect } from 'react'
import axios from 'axios'


const useCountry = () => {
  const [isNGN, setIsNGN] = useState(false)
  const [loadingCountry, setLoadingCountry] = useState(false)
	const [countryData, setCountryData] = useState(null)

  const checkCountry = async () => {
    setLoadingCountry(true)
    try {
      const res = await axios.get(`https://ipapi.co/json/`)
      setLoadingCountry(false)
			setCountryData(res.data)
      console.log(res.data.currency === 'NGN')
      if (res.data.currency === 'NGN') {
        setIsNGN(true)
      }
    } catch (error) {
      setIsNGN(false)
      setLoadingCountry(false)
    }
  }

  useEffect(() => {
    checkCountry()
  }, [])


  return {
    isNGN,
    checkCountry,
    loadingCountry,
		countryData
  }
}

export default useCountry